import { jsx as _jsx } from "react/jsx-runtime";
import { Combobox } from "@opala-ds/react";
import { useGetSchoolByCity } from "../../../queries/jepis";
import { Controller, useFormContext } from "react-hook-form";
export default function TechnicalSchoolNameSelect(_a) {
    var defaultValue = _a.defaultValue;
    var _b = useFormContext(), control = _b.control, setValue = _b.setValue, watch = _b.watch, errors = _b.formState.errors;
    var selectedSchoolCity = watch("escola.municipio");
    var _c = useGetSchoolByCity(selectedSchoolCity), schoolNames = _c.data, isFetching = _c.isFetching;
    var message = function (errorMessage) {
        if (errorMessage)
            return errorMessage;
        if (!selectedSchoolCity)
            return "Selecione uma cidade primeiro";
        return "";
    };
    return (_jsx(Controller, { control: control, name: "escola.id", render: function (_a) {
            var _b, _c, _d, _e, _f, _g;
            var field = _a.field;
            return (_jsx(Combobox, { label: "Escola", placeholder: ((_b = field === null || field === void 0 ? void 0 : field.value) === null || _b === void 0 ? void 0 : _b.toString()) ? (_c = field === null || field === void 0 ? void 0 : field.value) === null || _c === void 0 ? void 0 : _c.toString() : "Selecione", containerClassName: "".concat(field && "[&>button>div]:text-[#262626]", " ").concat(!(field === null || field === void 0 ? void 0 : field.value) && "cursor-not-allowed"), defaultValue: defaultValue, value: (_d = field === null || field === void 0 ? void 0 : field.value) === null || _d === void 0 ? void 0 : _d.toString(), onSelectValue: function (value) {
                    field.onChange(value);
                    var selectedSchool = schoolNames === null || schoolNames === void 0 ? void 0 : schoolNames.find(function (school) { return value === school.id.toString(); });
                    if (selectedSchool) {
                        setValue("escola.id", Number(selectedSchool.id));
                        setValue("escola.inep", selectedSchool.codigo_inep);
                    }
                }, disabled: isFetching || !selectedSchoolCity, items: schoolNames === null || schoolNames === void 0 ? void 0 : schoolNames.map(function (school) { return ({
                    label: school.nome,
                    value: school.id.toString(),
                }); }), helperText: message((_f = (_e = errors.escola) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.message), variant: ((_g = errors.escola) === null || _g === void 0 ? void 0 : _g.id) ? "critical" : "default" }));
        } }));
}
